import React from 'react';
import StickyBox from 'react-sticky-box';

import { AsyncCategorizer } from 'modules/filters/async';
import { AsyncPersistentStream } from 'modules/stream/async';
import { getNumberValueFromPx } from 'utils';
import useLeftSidebar from './useLeftSidebar';
import './leftSidebar.scss';

interface Props {}

const LeftSidebar: React.FC<Props> = () => {
    const { isVisible, isStreamPinAvailable } = useLeftSidebar();

    if (!isVisible) return null;

    const style = getComputedStyle(document.documentElement);

    const [topOffset, bottomOffset = 0, sidebarBottomOffset = 0] = [
        '--top-offset',
        '--bottom-offset',
        '--s-left-sidebar-bottom-offset',
    ].map(cssVar => getNumberValueFromPx(style.getPropertyValue(cssVar)));

    return (
        <div styleName="container">
            <StickyBox
                offsetTop={topOffset}
                offsetBottom={
                    isStreamPinAvailable
                        ? bottomOffset + sidebarBottomOffset
                        : 0
                }
            >
                <AsyncCategorizer />
            </StickyBox>

            <AsyncPersistentStream />
        </div>
    );
};

export default LeftSidebar;
